import React, { Component } from "react";
import CustomLoader from "../../../common/Loader";

class CheckboxViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Question_ID: this.props.Question_ID,
            Question_Answers: this.props.Question_Answers,
            Answer_ID: this.props.Answer_ID ? this.props.Answer_ID : 0,
            Response_Required: false,
            loading: true,
            isCheckboxChecked: null,
            preloadQAData: this.props.preloadQAData ? this.props.preloadQAData : {},
            SurveyMode: this.props.SurveyMode,
        };
    }

    async componentDidMount() {
        this.setState({ loading: false, isCheckboxChecked: this.state.preloadQAData.Answer_Text === 'true' });
    }

    handleSelection = (value) => {
        if (this.state.SurveyMode) {
            this.setState({ ...this.state, isCheckboxChecked: value })
            this.props.OnUpdate(this.props.Question_Number, {
                Responses: [
                    {
                        Question_Number:this.props.Question_Number,
                        Question_ID: this.state.Question_ID,
                        Answer_ID: this.state.Answer_ID,
                        Answer_Text: value
                    }
                ],
                Response_Required: false,
            });
        }
    };

    render() {
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }
        return (<input
            type='checkbox'
            Question_ID={this.state.Question_ID}
            name={this.state.Question_ID}
            className='form-check-input ml-2 displayEditInfo_cb'
            key={"cb" + this.state.Answer_ID}
            checked={this.state.isCheckboxChecked}
            onChange={(e) => this.handleSelection(e.target.checked)}
        />
        );
    }
}

export default CheckboxViewer;